import React from 'react';
import SectionHeader from './SectionHeader';
import CurrencyInput from './CurrencyInput';
import NotesInput from './NotesInput';

/**
 * Section 3 — Bills & Utilities
 */
export default function StepBillsUtilities({ data = {}, onChange }) {
  function set(field, value) {
    onChange({ ...data, [field]: value });
  }

  const fields = [
    { key: 'electric', label: 'Electric' },
    { key: 'gas', label: 'Gas' },
    { key: 'internet_cable', label: 'Internet / Cable' },
    { key: 'phone_mobile', label: 'Phone / Mobile' },
    { key: 'trash_recycling', label: 'Trash / Recycling' },
    { key: 'water_sewer', label: 'Water / Sewer' },
  ];

  const total = fields.reduce(
    (sum, f) => sum + (Number(data[f.key]) || 0),
    0
  );

  return (
    <div>
      <SectionHeader
        number={3}
        title="Bills & Utilities"
        tip="Streaming services and subscriptions (Netflix, Spotify, etc.) are
          captured in the Entertainment & Travel section."
      />

      <div className="cashflow-field-grid">
        {fields.map(({ key, label }) => (
          <CurrencyInput
            key={key}
            id={key}
            label={label}
            value={data[key] ?? null}
            onChange={(val) => set(key, val)}
          />
        ))}
      </div>

      {total > 0 && (
        <div className="cashflow-total-box mt-3">
          <span className="fw-semibold">3: Total Bills & Utilities</span>
          <span className="cashflow-total-amount">
            ${total.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
          </span>
        </div>
      )}

      <NotesInput value={data.notes} onChange={(val) => set('notes', val)} />
    </div>
  );
}
